<template lang="html">
<div>
    <v-header backTo="Login profissional">
        <router-link :to="{name: 'vibbrant-login'}" class="linkLogin">
          Sou profissional
        </router-link>
    </v-header>
  <v-page class="page-login company" :profile="profile" :style="{ backgroundImage: `url(${img_background_url})` }">
    <div class="autoLogin">
      <v-login class="card-login">
        <div class="center">
          <div class="loginLeft">
            <div class="company">
              <p>E</p>
              <p>M</p>
              <p>P</p>
              <p>R</p>
              <p>E</p>
              <p>S</p>
              <p>A</p>
            </div>

            <div>
              <img class="photo" :src="img_url">
            </div>
          </div>
          <div class="loginRight">
            <form @submit.prevent="login()">

              <v-text tag="h2" class="titleLoginEmpresa">Acesse sua conta</v-text>
              <v-input type="email" id="signin-email" v-model="email">E-mail</v-input>
              <v-input type="password" id="signin-password" v-model="password">Senha</v-input>
              <v-button type="submit" class="block mt-2" style="background-color: #0377AA; color:white">Login</v-button>

              <div class="helpers">
                <div class="dataRadio">
                  <v-input type="checkbox" class="inputRadio" id="" v-model="remember" @click="toggleRemember" />Lembrar os meus dados
                </div>
                <small class="d-flex justify-content-between">
                  <v-link :to="{ name: profile + '-recover-pass' }"><p class="registeHere">Esqueceu a senha?</p></v-link>
                </small>
              </div>
              <div class="register">
                <p>Não possuo uma conta</p>
                <a href="https://cadastro.vibbra.com.br/cliente" class="registerHere">Cadastre-se aqui</a>
              </div>
            </form>
          </div>
        </div>
      </v-login>
    </div>
  </v-page>
</div>
</template>


<script>
import apiClient from '@/api/client';
import apiVibbrante from '@/api/vibbrante';

export default {
  props: {
    profile: String,
  },
  data() {
    return {
      email: '',
      password: '',
      remember: false,
      today_date: new Date(),
      img_url: require('../../assets/photoPeople/Planos-Enterprise.png'),
      img_background_url: require('../../assets/background/fundoAzul.svg'),
      isLoading: false,
    };
  },

  mounted() {
    let code = this.$route.query.code;

    // Verificando se o parâmetro "code" existe
    if (code) {
      try {

        // Decodificando a string duas vezes
        let firstDecode = atob(code);
        let user = JSON.parse(atob(firstDecode));

        if(user.email && user.password){
          this.email = user.email
          this.password = user.password
          this.confirm_login = user.confirm_login
          this.login(user.email, user.password)
        }
      } catch (error) {
        console.error("Erro ao decodificar o código:", error);
      }
    } else {
      if (localStorage.remember) {
        this.email = localStorage.email;
        this.password = localStorage.password;
        this.remember = true;
        setTimeout(() => {
          this.isLoading = true;
        }, 5);
      }
    }
  },
  watch: {
    email(newName) {
      localStorage.email = newName;
    },
    password(newName) {
      localStorage.password = newName;
    },
    remember(newName) {
      localStorage.remember = newName;
    },
  },
  methods: {
    toggleRemember() {
      this.$emit('update:remember', !this.remember); // Emitir evento para atualizar a propriedade
    },
    login(email, password) {
      if (this.profile === 'client') {
        apiClient
          .sign_in(this.email, this.password)
          .then((response) => {
            if (response.status === 200) {
              this.$store.dispatch('loginClient', response);
              if(this.confirm_login){
                  this.$router.push({
                    name: 'client-new-pass',
                    query: { confirm: true }
                  });
                } else {
                  this.$router.push({ name: 'client-dashboard' });
                }
            }
          })
          .catch((e) => {
            this.$notify(
              'Opa! Ocorreu um erro não esperado. Recarregue a página e tente novamanete.',
              'error'
            );
          });
      } else {
        apiVibbrante
          .sign_in(this.email, this.password)
          .then((response) => {
            if (response.status === 200) {
              this.$store.dispatch('loginVibbrante', response);
              this.$router.push({ name: 'vibbrant-dashboard' });
            }
          })
          .catch((e) => {
            this.$notify(
              'Opa! Ocorreu um erro não esperado. Recarregue a página e tente novamanete.',
              'error'
            );
          });
      }

      if (this.remember === true) {
        localStorage.email = this.email;
        localStorage.password = this.password;
        localStorage.remember = true;
      } else {
        localStorage.removeItem('email');
        localStorage.removeItem('password');
        localStorage.removeItem('remember');
      }
    },
  },
};
</script>

<style lang="scss">
 .linkLogin{
     color: white !important;

  &:hover{
    color: #0377AA !important;
      text-decoration: none;
  }


    }
.registeHere{
  color: #0377AA !important;

  &:hover{
    color: #0377AA !important;
    text-decoration: none;
  }
}
.page {
    min-height: calc(100vh - 60px);
}
.page-login {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-size: cover;
  background-repeat: no-repeat;

  .autoLogin {
    width: 75%;
    flex: 1;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .card-login {
    max-width: 100%;
    flex-basis: auto;
    flex-grow: 1;
    border-radius: 22px;
    justify-content: center;
    @include media-breakpoint-up(md) {
      width: 100%;
    }
    .center {
      display: flex;
      align-items: center;
      padding: 2rem 2rem 0 0;

      @include media-breakpoint-down(md) {
        padding: 2rem;
      }
    }
    .loginLeft {
      display: flex;
      align-items: flex-end;

      height: 100%;
      width: 60%;
      @include media-breakpoint-down(md) {
        display: none;
      }
    }

    .company {
      background-color: #0377aa;
      color: white;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px 25px;
      height: calc(100vh - 450px);
      align-items: center;
      font-weight: 700px;
      font-weight: 700;
      font-size: 20px;
      border-radius: 0 10px 0 20px;

      p {
        margin: 0;
      }
    }
    .loginRight {
      width: 40%;
      @include media-breakpoint-down(md) {
        width: 100%;
      }
    }

    .logo {
      height: 60px;
      text-align: center;
      margin: 0 0 30px 0;
    }


    .photo {
      height: 500px;
    }

    .titleLoginEmpresa{
      font-size: 45px;
      font-weight: bold;
      margin-bottom: 40px;
      text-align: center;

      @include media-breakpoint-down(md) {
        font-size: 35px;
      }
    }
    .dataRadio {
      display: flex;
      align-items: center;
    }
    .inputRadio {
      margin: 0 !important;
    }
    .helpers {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      @include media-breakpoint-down(md) {
        flex-direction: column;
      }
    }
    .register {
      display: flex;
      justify-content: center;
      gap: 1rem;
      margin-top: 20px;
      @include media-breakpoint-down(md) {
        flex-direction: column;
        text-align: center;
        gap: 0;
        p {
          margin: 0;
        }
      }
    }
  }
  footer.page-footer {
    color: white;
    margin-top: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/login.vue